import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Delete } from '@mui/icons-material';
import { TableCell, TableRow, Tooltip, FormControlLabel, Checkbox, IconButton } from '@mui/material';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { TextField } from '@totalsoft/rocket-ui';

const EngineScoringClassificationFinancialIndicatorListItemComponent = ({
  financialIndicator,
  dispatch,
  isReadOnly,
  validation,
  scoringFinancialIndicatorOptions,
  financialIndicatorIndex,
  classificationIndex
}) => {
  const { t } = useTranslation();
  const onPropertyChanged = (property, propertyValue, propertyName, propertyNameValue) => {
    dispatch({
      type: 'OnClassificationFinancialIndicatorChanged',
      property,
      propertyValue,
      propertyName,
      propertyNameValue,
      financialIndicatorIndex,
      classificationIndex
    });
  };

  const onDeleteFinancialIndicator = () => {
    dispatch({
      type: 'OnClassificationFinancialIndicatorDeleted',
      key: financialIndicator.engineScoringClassificationXFinancialId,
      financialIndicatorIndex,
      classificationIndex
    });
  };

  return (
    <TableRow hover>
      <TableCell>
        <TextField
          isNumeric
          fullWidth
          decimalScale={0}
          value={financialIndicator.orderNo}
          disabled={isReadOnly}
          onChange={event => onPropertyChanged('orderNo', event)}
          error={!isValid(validation.orderNo)}
          helperText={getErrors(validation.orderNo)}
        />
      </TableCell>
      <TableCell>
        <Autocomplete
          fullWidth
          value={{ id: financialIndicator.financialIndicatorId, name: financialIndicator.financialIndicatorName }}
          options={scoringFinancialIndicatorOptions}
          isDisabled={isReadOnly}
          onChange={event =>
            onPropertyChanged(
              'financialIndicatorId',
              event !== null ? event.id : null,
              'financialIndicatorName',
              event !== null ? event.name : null
            )
          }
          error={!isValid(validation.financialIndicatorId)}
          helperText={getErrors(validation.financialIndicatorId)}
          isSearchable={true}
        />
      </TableCell>
      <TableCell>
        <FormControlLabel
          control={
            <Checkbox
              checked={financialIndicator.isMandatory || false}
              disabled={isReadOnly}
              onChange={event => onPropertyChanged('isMandatory', event.target.checked)}
              color='primary'
            />
          }
        />
      </TableCell>
      <TableCell>
        <Tooltip title={t('EngineScoring.EngineClassifications.FinancialIndicator.DeleteTooltip')}>
          <IconButton color='primary' onClick={onDeleteFinancialIndicator} disabled={isReadOnly}>
            <Delete />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

EngineScoringClassificationFinancialIndicatorListItemComponent.propTypes = {
  financialIndicator: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  scoringFinancialIndicatorOptions: PropTypes.array.isRequired,
  financialIndicatorIndex: PropTypes.number.isRequired,
  classificationIndex: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired
};

export default EngineScoringClassificationFinancialIndicatorListItemComponent;
